<button
  id="externalLinkButton"
  class="accent"
  mat-flat-button
  *ngIf="!isMoreOption"
  appStopPropagation
  (click)="openExternalLink()">
  {{ 'general.open' | translate }}
</button>
<button mat-menu-item *ngIf="isMoreOption" appStopPropagation (click)="openExternalLink()">
  <span class="odilo-icon" [className]="record.icon.className" aria-hidden="true">{{ recordIcon }}</span>
  {{ 'general.open' | translate }}
</button>
